<template>
  <div @click.self="closeModal">
    <div
      id="modal-block-extra-large"
      class="modal show"
      tabindex="-1"
      role="dialog"
      aria-modal="true"
      style="display: block"
    >
      <div class="modal-dialog" :class="modalClasses" role="document">
        <div class="modal-content">
          <div class="block block-rounded block-transparent mb-0">
            <div class="block-header block-header-default">
              <h3 class="block-title">{{ title }}</h3>
              <div class="block-options">
                <button
                  type="button"
                  class="btn-block-option"
                  aria-label="Close"
                  @click="closeModal"
                >
                  <i class="fa fa-fw fa-times"></i>
                </button>
              </div>
            </div>
            <div class="block-content fs-sm">
              <slot></slot>
            </div>
          </div>
          <div class="block-content block-content-full text-end bg-body">
            <button
              type="button"
              class="btn btn-sm btn-alt-secondary me-1"
              @click="closeModal"
            >
              Close
            </button>
            <button
              v-if="showSave"
              :disabled="disableSave"
              type="button"
              class="btn btn-sm btn-primary"
              @click="save"
            >
              {{ saveButtonText }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-backdrop show" @click="closeModal"></div>
  </div>
</template>

<script setup>
const props = defineProps({
  title: {
    type: String,
    required: true,
  },
  modalClasses: {
    type: String,
    default: "",
  },
  saveButtonText: {
    type: String,
    default: "Save",
  },
  disableSave: {
    type: Boolean,
    default: false,
  },
  showSave: {
    type: Boolean,
    default: true,
  },
});

const emit = defineEmits(["close", "save"]);

function closeModal() {
  emit("close");
}

function save() {
  emit("save");
}
</script>
